export const UPDATE_IMPORT_EXPORT_WIZARD_VISIBILITY = 'UPDATE_IMPORT_EXPORT_WIZARD_VISIBILITY';
export type UPDATE_IMPORT_EXPORT_WIZARD_VISIBILITY = typeof UPDATE_IMPORT_EXPORT_WIZARD_VISIBILITY;

export interface UpdateImportExportWizardVisibility {
    type: UPDATE_IMPORT_EXPORT_WIZARD_VISIBILITY;
    isVisible: boolean;
}

export function updateImportExportWizardVisibilityAction(isVisible: boolean): UpdateImportExportWizardVisibility {
    return {
        type: UPDATE_IMPORT_EXPORT_WIZARD_VISIBILITY,
        isVisible
    };
}
